import { render, staticRenderFns } from "./TeaserImage.vue?vue&type=template&id=1d170160&functional=true&"
import script from "./TeaserImage.vue?vue&type=script&lang=ts&"
export * from "./TeaserImage.vue?vue&type=script&lang=ts&"
import style0 from "./TeaserImage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports